import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskLines, MaskLinesInView } from "@/components/Reveal";
import CTASection from "@/components/CTASection";
import { SCOTT } from "@/lib/data";
import scottImg from "@/assets/brand/scott.png";

export default function About() {
  return (
    <>
      <section className="bg-cream grain pt-36 pb-16 md:pt-48 md:pb-20 relative">
        <div className="container-editorial relative z-10 grid lg:grid-cols-[1.1fr_0.9fr] gap-12 lg:gap-16 items-end">
          <div>
            <Reveal>
              <p className="eyebrow text-amber-deep mb-8 flex items-center gap-3">
                <span className="w-10 h-px bg-amber-deep" /> The Advisor
              </p>
            </Reveal>
            <h1 className="font-serif font-bold text-5xl md:text-7xl lg:text-8xl text-blue leading-[0.95] tracking-tight">
              <MaskLines lines={["Scott"]} delay={0.1} />
              <MaskLines lines={["Bucher"]} className="italic text-amber-deep" delay={0.24} />
            </h1>
            <Reveal delay={0.5}>
              <p className="font-body text-slate mt-6 text-lg">
                {SCOTT.title} · {SCOTT.subtitle}
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.2} className="relative">
            <div className="relative max-w-md ml-auto">
              <div className="absolute -inset-3 border border-amber/40" />
              <img src={scottImg} alt="Scott Bucher" className="relative w-full object-cover grayscale-[10%]" />
            </div>
          </Reveal>
        </div>
      </section>

      <section className="bg-blue text-cream py-20 md:py-28 grain relative">
        <div className="container-editorial relative z-10 max-w-4xl">
          <MaskLinesInView
            lines={["\u201cSuccessful exits don't", "happen by accident."]}
            className="font-serif font-bold text-3xl md:text-5xl lg:text-6xl text-cream leading-[1.05]"
          />
          <MaskLinesInView
            lines={["They happen on purpose.\u201d"]}
            className="font-serif font-bold italic text-3xl md:text-5xl lg:text-6xl text-amber-bright leading-[1.05] mt-2"
          />
          <Reveal delay={0.2}>
            <p className="font-body text-cream/65 mt-8 max-w-xl">
              The result of disciplined planning and preparation, the belief at the heart of every
              engagement.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-cream py-24 md:py-32">
        <div className="container-editorial grid lg:grid-cols-[1.4fr_0.6fr] gap-14 lg:gap-20">
          <div className="space-y-8">
            <Reveal>
              <p className="eyebrow text-amber-deep mb-2">The Story</p>
            </Reveal>
            {SCOTT.bio.map((para, i) => (
              <Reveal key={i} delay={i * 0.06}>
                <p
                  className={`font-body leading-relaxed ${
                    i === 0 ? "text-2xl md:text-3xl font-serif font-bold text-blue" : "text-lg text-charcoal/75"
                  }`}
                >
                  {para}
                </p>
              </Reveal>
            ))}
          </div>
          <div className="lg:border-l lg:border-blue/15 lg:pl-12">
            <Reveal>
              <p className="eyebrow text-amber-deep mb-8">At a Glance</p>
            </Reveal>
            <div className="space-y-px">
              {SCOTT.facts.map((f, i) => (
                <Reveal key={f.label} delay={i * 0.06}>
                  <div className="py-6 border-b border-blue/12">
                    <p className="font-serif font-bold text-4xl md:text-5xl text-blue">{f.value}</p>
                    <p className="eyebrow text-[0.6rem] text-slate mt-2">{f.label}</p>
                  </div>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.3}>
              <Link
                to="/contact"
                data-testid="about-cta"
                className="mt-10 inline-flex items-center gap-2 bg-blue text-cream px-8 py-4 eyebrow text-xs hover:bg-amber-deep transition-colors"
              >
                Work With Scott <ArrowUpRight size={16} />
              </Link>
            </Reveal>
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
